var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.5313 6.93706L17.0624 2.46923C16.9139 2.32062 16.7375 2.20274 16.5433 2.12231C16.3492 2.04188 16.1411 2.00049 15.931 2.00049C15.7208 2.00049 15.5128 2.04188 15.3186 2.12231C15.1245 2.20274 14.9481 2.32062 14.7995 2.46923L2.46899 14.7998C2.31978 14.9478 2.20147 15.124 2.12096 15.3182C2.04045 15.5123 1.99934 15.7205 2.00001 15.9307V20.3995C2.00001 20.8239 2.16857 21.2308 2.46862 21.5309C2.76867 21.8309 3.17562 21.9995 3.59995 21.9995H8.06878C8.27896 22.0002 8.48718 21.959 8.68134 21.8785C8.87549 21.798 9.0517 21.6797 9.19973 21.5305L17.5664 13.1648L17.9144 14.5548L14.2345 18.2336C14.0844 18.3836 14.0001 18.5871 14 18.7992C13.9999 19.0114 14.0841 19.215 14.234 19.3651C14.384 19.5152 14.5875 19.5996 14.7997 19.5997C15.0119 19.5998 15.2154 19.5156 15.3655 19.3656L19.3653 15.3657C19.4632 15.2681 19.534 15.1467 19.571 15.0136C19.608 14.8804 19.6098 14.7399 19.5763 14.6058L18.8864 11.8449L21.5313 9.19997C21.6799 9.0514 21.7978 8.87501 21.8782 8.68087C21.9586 8.48673 22 8.27865 22 8.06851C22 7.85838 21.9586 7.6503 21.8782 7.45616C21.7978 7.26202 21.6799 7.08563 21.5313 6.93706ZM3.59995 17.5307L6.46884 20.3995H3.59995V17.5307ZM8.39976 20.0686L3.93093 15.5997L12.3996 7.13105L16.8684 11.5999L8.39976 20.0686ZM17.9994 10.4689L13.5316 6.00009L15.9315 3.60019L20.3993 8.06901L17.9994 10.4689Z",
    fill: "#0D0E10"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.f298f7bfe2fdd9b4d8f61ea56bd2987b.svg";
export { ForwardRef as ReactComponent };